<template>
        <div class="shop">
            <img class="shop__banner" :src="bannerImage"/>
            <shop-header :heading="$t('SHOP_HEADING')" :subheading="$t('SHOP_SUBHEADING')"/>
            <div class="center-banner h-auto mx-2 py-2 bg-white md:border md:border-black" v-show="hasShopCoupon && isDEU">
                <p v-html="$t('SHOP_COUPON_AVAILABLE', {couponAmount})"></p>
            </div>
            <div class="shop__desktop">
                <div class="shop__filter-column">
                    <filters
                        class="shop__filters"
                        :title="$t('FILTER_TITLE')"
                        :categories="categories"
                        @input="filterProducts"
                        @clear="clear"/>
                </div>
                <div class="shop__product-column">
                    <menu-bar
                        @input="filterProducts"/>
                    <div class="shop__product-container">
                        <div class='shop__product-block' v-for="(item, key) in products" :key="key">
                            <product-card :item="item" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Filters from '@/components/partials/account/shop/Filters';
import MenuBar from '@/components/partials/account/shop/MenuBar';
import ShopHeader from '@/components/partials/account/shop/ShopHeader';
import ProductCard from '@/components/partials/account/shop/ProductCard';

export default {
    name: 'Shop',
    components: { MenuBar, ProductCard, ShopHeader, Filters },
    computed: {
        ...mapGetters({
            products: 'shop/getProducts',
            categories: 'shop/getCategories',
            orderSummary: 'shop/getOrderSummary',
            isDEU: 'localisation/isDEU',
        }),
        shopCoupons() {
            if (this.orderSummary) {
                const bannerData = this.orderSummary.filter(item => item.shop_coupons);
                return bannerData.length ? bannerData[0].shop_coupons : null;
            }
            return null;
        },
        hasShopCoupon() {
            return this.shopCoupons && this.shopCoupons?.length !== 0 && this.shopCoupons?.filter(eachCoupon => eachCoupon.category.toUpperCase() === 'SHOP').length !== 0;
        },
        couponApplied() {
            const amountCoupons = this.shopCoupons?.filter(eachCoupon => eachCoupon.discount_type === 'amount' && eachCoupon.category.toUpperCase() === 'SHOP');
            const percentageCoupons = this.shopCoupons?.filter(eachCoupon => eachCoupon.discount_type === 'percentage' && eachCoupon.category.toUpperCase() === 'SHOP');
            if (amountCoupons.length > 0) return amountCoupons;
            else if (percentageCoupons.length > 0) return percentageCoupons;
        },
        couponAmount() {
            if (!this.couponApplied) return;
            const discountType = (this.couponApplied.length !== 0) && this.couponApplied[0].discount_type;
            let discountValue = 0;
            if (discountType === 'amount' && this.couponApplied.length > 1) {
                let netDiscount = 0;
                this.couponApplied.forEach(item => {
                    netDiscount = netDiscount + item.discount;
                });
                discountValue = netDiscount;
            } else {
                discountValue = this.couponApplied.length !== 0 && this.couponApplied[0].discount;
            }
            if (discountType === 'percentage') {
                const saving = this.order?.total * (discountValue / 100);
                return saving.toFixed(2);
            } else if (discountType === 'amount') {
                const saving = discountValue * 0.01;
                return saving.toFixed(2);
            }
            return 0;
        },
        showBanner() {
            return this.shopCoupons?.length !== 0 && this.shopCoupons?.filter(item => item !== null);
        },
        bannerImage() {
            const isMobile = this.window.width < this.window.mobileBreakpoint;
            const deviceSrc = isMobile ? 'mobile' : 'desktop';
            const imageUrl = `https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/shop/banner/${deviceSrc}.jpg`;
            return imageUrl;
        },
    },
    created() {
        this.$store.dispatch('shop/fetchProducts', { active_in: 'shop' });
    },
    data() {
        return {
            window: {
                width: 0,
                mobileBreakpoint: 768,
            },
        };
    },
    methods: {
        ...mapActions({
            updateFilteredProducts: 'shop/updateFilteredProducts',
        }),
        ...mapMutations({
            clearFilteredProducts: 'shop/clearFilteredProducts',
        }),
        filterProducts(filter) {
            if (!filter.length) {
                this.clearFilteredProducts();
            } else {
                this.updateFilteredProducts(filter);
            }
        },
        clear() {
            this.clearFilteredProducts();
        },
        handleResize() {
            this.window.width = window.innerWidth;
        },
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
};
</script>

<style lang="css" scoped>
.center-banner{
    margin: auto;
    width: 50%;
    text-align: center;
}
</style>
